// @ts-check
import { VoyageTooltip } from './voyage-tooltip';

export const VoyageTooltipManager = new class
{
    constructor()
    {
        this._domParent = null;
        this._tooltips = new Map();
    }

    setTooltipsParentElement(domElement)
    {
        this._domParent = domElement;
    }

    createTooltip(ownerElement, forElement, text, properties)
    {
        this.removeTooltip(ownerElement, forElement);

        /** @type {VoyageTooltip} */
        const newTooltip = (document.createElement('voyage-tooltip'));
        newTooltip.for = forElement;
        let htmlContent = false;
        
        if (properties)
        {
            for (const propName in properties)
            {
                if (propName === "htmlContent")
                {
                    htmlContent = properties.htmlContent;
                }
                else
                {
                    newTooltip[propName] = properties[propName];
                }
            }
        }

        if (htmlContent)
        {
            newTooltip.innerHTML = text;
        }
        else
        {
            newTooltip.textContent = text;
        }
        const parent = this._domParent || document.body;
        parent.appendChild(newTooltip);

        if (!this._tooltips.has(ownerElement))
        {
            this._tooltips.set(ownerElement, new Map());
        }
        this._tooltips.get(ownerElement).set(forElement, newTooltip);

        return newTooltip;
    }

    removeTooltip(ownerElement, forElement)
    {
        if (this._tooltips.has(ownerElement))
        {
            const tooltips = this._tooltips.get(ownerElement);
            if (tooltips.has(forElement))
            {
                const tooltip = tooltips.get(forElement);
                try 
                {
                    tooltip.remove();
                }
                catch (e)
                {
                    console.warn(e);
                }
                tooltips.delete(forElement);
                if (tooltips.size === 0)
                {
                    this._tooltips.delete(ownerElement);
                }
            }
        }
    }

    removeTooltips(ownerElement)
    {
        if (this._tooltips.has(ownerElement))
        {
            for (const forElement of this._tooltips.get(ownerElement).keys())
            {
                this.removeTooltip(ownerElement, forElement);
            }
        }
    }

}
